export default "__VITE_ASSET__DqVSamWR__"